module.exports = __webpack_public_path__ + "static/media/chat-disable.22554826.svg";